import { Box } from "@mui/material";
import styled from "styled-components";

export const BlockOffsStyled = styled(Box)(({ theme }) => {
  return {
    ".header-wrapper": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "20px",
      ".btn-wrapper": {
        display: "flex",
        flexDirection: "row",
        columnGap: "16px",
        alignItems: "center",
      },
    },
    ".tabs-children": {
      paddingTop: "0px",
    },
    ".main-wrapper": {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      marginTop: "16px",
    },
    ".card-wrapper": {
      display: "flex",
      flexDirection: "column",
      rowGap: "16px",
      padding: "16px",
      borderRadius: "8px",
      color: theme.palette.secondary.contrastText,
    },
    ".text-btn": {
      display: "block",
      width: "100%",
      ...theme.typography.body3,
    },
    ".icon-btn": {
      display: "none",
    },

    /* Tabs Styling */
    ".MuiTabs-root": {
      ".MuiTabs-flexContainer": {
        borderBottom: "none !important",
      },
      ".MuiTab-root": {
        textTransform: "none",
        fontSize: "16px",
        fontWeight: theme.typography.body1.fontWeight,
        padding: "8px 16px",
        color: theme.palette.secondary.main,
        border: "1px solid transparent",
        borderRadius: "24px",
        minWidth: "200px",
        backgroundColor: theme.palette.common.white,
        transition: "all 0.3s ease",

        "&.Mui-selected": {
          color: theme.palette.primary.main,
          border: `1px solid var(--royal-blue-color)`,
        },

        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      },
      ".MuiTabs-indicator": {
        display: "none",
      },
    },
    [`@media (max-width:${theme.breakpoints.values.sm}px)`]: {
      ".MuiTab-root": {
        minWidth: "120px !important",
        fontSize: "13px !important",
      },
      ".text-btn": {
        display: "none",
      },
      ".icon-btn": {
        display: "block",
        ".MuiButton-startIcon":{
          margin:'-2px !important'
        }
      },
    },
  };
});
